<template>
  <div class="bread-crumb flex align-items-center">
    <span>当前位置：</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <div v-if="breadArray.length > 0">
        <template v-for="(item, index) in breadArray">
          <el-breadcrumb-item
            v-if="item.path"
            :key="index"
            :to="{
              path: item.path,
              query: Object.assign({ breadpath: 'breadpath' }, item.query),
            }"
            >{{ item.name == "百科" ? name : item.name }}</el-breadcrumb-item
          >
          <el-breadcrumb-item v-else :key="index || 0">{{
            item.name
          }}</el-breadcrumb-item>
        </template>
      </div>
      <div v-else>
        <el-breadcrumb-item> 百科页 > 健康百科 </el-breadcrumb-item>
      </div>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "breadCrumb",
  props: ["name"],
  computed: {
    ...mapState(["breadArray"]),
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.bread-crumb {
  color: rgba(124, 132, 149, 1);
  font-size: 13px;
  margin-bottom: 20px;
  :deep(.el-breadcrumb__item) {
    font-size: 13px;
    color: rgba(124, 132, 149, 1);
    .is-link {
      font-weight: normal;
      color: rgba(124, 132, 149, 1);
    }
    &:last-child {
      .is-link {
        color: rgba(76, 84, 99, 1);
      }
    }
  }
}
</style>
